<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { cartMethods, cartComputed } from "@/state/helpers";

export default {
  page: {
    title: "Checkout",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Checkout",
      items: [
        { text: "Ecommerce", href: "/" },
        { text: "Checkout", active: true },
      ],
      loader: false,
      ordernote: "",
      payoption: "3",
      first_name: "",
      last_name: "",
      email: "",
      telephone: "",
      nationality: "",
      address: "",
      user_type: "",
      gender: "",
      amount: 0,
    };
  },
  methods: {
    ...cartMethods,
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "products/" + name;
      return imagelink;
    },
    async fetchData() {
      let url = "/fetchdata";
      await axios.get(url).then((response) => {
        if (response.status == 200) {
          this.first_name = response.data.first_name;
          this.last_name = response.data.last_name;
          this.telephone = response.data.contact;
          this.email = response.data.email;
          this.gender = response.data.gender;
          this.address = response.data.address;
          this.nationality = response.data.nationality;
          this.user_type = response.data.user_type;
        }
      });
    },
    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async Checkout() {
      this.loader = true;
      let obj = {
        cart: this.Cart,
        ordernote: this.ordernote,
        payoption: this.payoption,
        amount: Number(this.cart_total) + Number(1000),
      };
      let url = "/checkout";
      await axios.post(url, obj).then((response) => {
        if (response.status == 200) {
          this.fetchCarts();
          this.loader = false;

          if (response.data.payment_url) {
            window.location.href = response.data.payment_url
          }

          // this.$toast.success(response.data.message);
          // this.$router.push({
          //   name: "order",
          //   query: { booking_id: response.data.booking_id },
          // });
        }
      });
    },
  },
  mounted() {
    this.fetchCarts();
    this.fetchData();
  },
  computed: {
    ...cartComputed,
    cart_total() {
      var total = 0;
      this.carts.forEach((item) => {
        var item_total = item.product.price * item.quantity;
        total = total + item_total;
      });
      return total;
    },
    Cart() {
      return this.carts.map((d) => ({
        id: d.id,
        product: d.product.product_id,
        quantity: d.quantity,
        vendor_id: d.vendor_id,
      }));
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="modern-checkout">

      <div class="checkout-container">
        <!-- Left Column - Checkout Form -->
        <div class="checkout-main">
          <!-- Personal Information Card -->
          <div class="checkout-card">
            <div class="card-header-modern">
              <div class="header-icon">
                <i class="mdi mdi-account-circle"></i>
              </div>
              <div class="header-text">
                <h3>Personal Information</h3>
                <p>Please verify your contact details</p>
              </div>
            </div>

            <form class="checkout-form">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">
                    <i class="mdi mdi-account-outline"></i>
                    Full Name
                  </label>
                  <div class="input-wrapper">
                    <input
                      v-model="first_name"
                      type="text"
                      class="form-control"
                      placeholder="Enter your full name"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="mdi mdi-email-outline"></i>
                    Email Address
                  </label>
                  <div class="input-wrapper">
                    <input
                      v-model="email"
                      type="email"
                      class="form-control"
                      placeholder="your.email@example.com"
                    />
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">
                    <i class="mdi mdi-phone"></i>
                    Telephone
                  </label>
                  <div class="input-wrapper">
                    <input
                      v-model="telephone"
                      type="tel"
                      class="form-control"
                      placeholder="Enter phone number"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="mdi mdi-map-marker"></i>
                    Address
                  </label>
                  <div class="input-wrapper">
                    <input
                      v-model="address"
                      type="text"
                      class="form-control"
                      placeholder="Enter your address"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group full-width">
                <label class="form-label">
                  <i class="mdi mdi-note-text-outline"></i>
                  Booking Note
                  <span class="optional">(Optional)</span>
                </label>
                <div class="input-wrapper">
                  <textarea
                    v-model="ordernote"
                    class="form-control textarea"
                    rows="4"
                    placeholder="Add any special instructions or notes for your booking..."
                  ></textarea>
                </div>
              </div>
            </form>
          </div>

          <!-- Payment Method Card -->
          <!-- <div class="checkout-card">
            <div class="card-header-modern">
              <div class="header-icon">
                <i class="mdi mdi-credit-card"></i>
              </div>
              <div class="header-text">
                <h3>Payment Method</h3>
                <p>Select your preferred payment option</p>
              </div>
            </div>

            <div class="payment-methods">
              <label class="payment-option" :class="{ active: payoption === '1' }">
                <input type="radio" v-model="payoption" value="1" class="payment-radio" />
                <div class="payment-content">
                  <div class="payment-icon credit-card">
                    <i class="mdi mdi-credit-card"></i>
                  </div>
                  <div class="payment-details">
                    <h4>Credit / Debit Card</h4>
                    <p>Visa, Mastercard, American Express</p>
                  </div>
                  <div class="payment-checkmark">
                    <i class="mdi mdi-check-circle"></i>
                  </div>
                </div>
              </label>

              <label class="payment-option" :class="{ active: payoption === '3' }">
                <input type="radio" v-model="payoption" value="3" class="payment-radio" />
                <div class="payment-content">
                  <div class="payment-icon cash">
                    <i class="mdi mdi-cash"></i>
                  </div>
                  <div class="payment-details">
                    <h4>Cash on Delivery</h4>
                    <p>Pay when you receive your service</p>
                  </div>
                  <div class="payment-checkmark">
                    <i class="mdi mdi-check-circle"></i>
                  </div>
                </div>
              </label>
            </div>
          </div> -->

          <!-- Back to Cart Button -->
          <div class="checkout-actions">
            <router-link to="/cart" class="btn-back">
              <i class="mdi mdi-arrow-left"></i>
              Back to Cart
            </router-link>
          </div>
        </div>

        <!-- Right Column - Order Summary -->
        <div class="checkout-sidebar">
          <div v-if="carts.length" class="summary-card">
            <div class="summary-header">
              <i class="mdi mdi-receipt-text-outline"></i>
              <h3>Order Summary</h3>
            </div>

            <!-- Cart Items -->
            <div class="summary-items">
              <div v-for="data in carts" :key="data.id" class="summary-item">
                <div class="item-image">
                  <img :src="getFiles(data.product.photo)" :alt="data.product.name" />
                </div>
                <div class="item-details">
                  <router-link
                    :to="{ path: '/product', query: { id: data.product.product_id }}"
                    class="item-name"
                  >
                    {{ data.product.name }}
                  </router-link>
                  <p class="item-description">{{ data.product.description }}</p>
                  <div class="item-meta">
                    <span class="item-quantity">{{ data.quantity }}X</span>
                    <span class="item-price">{{ commas(data.product.price) }} AED</span>
                  </div>
                </div>
                <div class="item-total">
                  {{ commas(Number(data.product.price) * Number(data.quantity)) }} AED
                </div>
              </div>
            </div>

            <!-- Pricing Breakdown -->
            <div class="summary-breakdown">
              <div class="breakdown-row">
                <span class="breakdown-label">Subtotal</span>
                <span class="breakdown-value">{{ commas(cart_total) }} AED</span>
              </div>
              <div class="breakdown-row">
                <span class="breakdown-label">
                  Service Fee
                  <i class="mdi mdi-information-outline" title="Platform service fee"></i>
                </span>
                <span class="breakdown-value">1,000 AED</span>
              </div>
              <div class="breakdown-divider"></div>
              <div class="breakdown-row total-row">
                <span class="breakdown-label">Total Amount</span>
                <span class="breakdown-value">
                  {{ commas(Number(cart_total) + Number(1000)) }} AED
                </span>
              </div>
            </div>

            <!-- Place Order Button -->
            <div class="summary-actions">
              <button @click="Checkout()" :disabled="loader" class="btn-place-order">
                <span v-if="loader" class="loading-content">
                  <b-spinner small class="btn-spinner" />
                  Processing...
                </span>
                <span v-else class="order-content">
                  <i class="mdi mdi-check-circle"></i>
                  Place Order
                </span>
              </button>
              
              <div class="security-info">
                <i class="mdi mdi-shield-check"></i>
                <span>Secure checkout powered by Ovvura</span>
              </div>
            </div>
          </div>

          <!-- Empty Cart State -->
          <div v-else class="empty-cart-card">
            <div class="empty-cart-icon">
              <i class="mdi mdi-cart-outline"></i>
            </div>
            <h3>Your cart is empty</h3>
            <p>Add some services to your cart to continue</p>
            <router-link to="/" class="btn-browse">
              <i class="mdi mdi-magnify"></i>
              Browse Services
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
/* Modern Checkout Styles */
.modern-checkout {
  max-width: 1400px;
  margin: 0 auto;
  /* padding: 2rem 1rem; */
  font-family: Arial, Helvetica, sans-serif;
}

/* Checkout Container */
.checkout-container {
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 1rem;
  align-items: start;
}

@media (max-width: 1024px) {
  .checkout-container {
    grid-template-columns: 1fr;
  }
}

/* Checkout Card */
.checkout-card {
  background: white;
  border-radius: 16px;
  padding: 1.2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
}

.card-header-modern {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #f8f9fa;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #E6FDFF 0%, #d4f5f7 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #3A2B78FF;
  flex-shrink: 0;
}

.header-text h3 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.25rem 0;
}

.header-text p {
  font-size: 0.9rem;
  color: #6c757d;
  margin: 0;
}

/* Checkout Form */
.checkout-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-weight: 500;
  color: #495057;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-label i {
  font-size: 1.1rem;
  color: #3A2B78FF;
}

.optional {
  color: #6c757d;
  font-weight: 400;
  font-size: 0.85rem;
}

.input-wrapper {
  position: relative;
}

.form-control {
  width: 100%;
  padding: 0.875rem 1rem !important;
  border: 2px solid #e1e8ed !important;
  border-radius: 10px !important;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: white;
}

.form-control:focus {
  border-color: #3A2B78FF !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 168, 168, 0.1) !important;
  outline: none;
}

.form-control.textarea {
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

/* Payment Methods */
.payment-methods {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.payment-option {
  background: white;
  border: 2px solid #e1e8ed;
  border-radius: 12px;
  padding: 1.2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: block;
}

.payment-option:hover {
  border-color: #3A2B78FF;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 168, 168, 0.15);
}

.payment-option.active {
  border-color: #3A2B78FF;
  background: linear-gradient(135deg, #E6FDFF 0%, #d4f5f7 100%);
  box-shadow: 0 4px 12px rgba(0, 168, 168, 0.2);
}

.payment-radio {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.payment-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.payment-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: white;
  flex-shrink: 0;
}

.payment-icon.credit-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.payment-icon.paypal {
  background: linear-gradient(135deg, #0070ba 0%, #1546a0 100%);
}

.payment-icon.cash {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}

.payment-details {
  flex: 1;
}

.payment-details h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.25rem 0;
}

.payment-details p {
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0;
}

.payment-checkmark {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #e1e8ed;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: white;
  transition: all 0.3s ease;
}

.payment-option.active .payment-checkmark {
  background: #3A2B78FF;
  transform: scale(1.1);
}

/* Checkout Actions */
.checkout-actions {
  margin-top: 0.5rem;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  background: white;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  color: #495057;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-back:hover {
  border-color: #3A2B78FF;
  color: #3A2B78FF;
  transform: translateX(-4px);
}

/* Summary Card */
.summary-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 2rem;
}

.summary-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f8f9fa;
}

.summary-header i {
  font-size: 1.5rem;
  color: #3A2B78FF;
}

.summary-header h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

/* Summary Items */
.summary-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.summary-items::-webkit-scrollbar {
  width: 6px;
}

.summary-items::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 10px;
}

.summary-items::-webkit-scrollbar-thumb {
  background: #3A2B78FF;
  border-radius: 10px;
}

.summary-item {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.summary-item:hover {
  background: #E6FDFF;
}

.item-image {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-details {
  flex: 1;
  min-width: 0;
}

.item-name {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 0.95rem;
  text-decoration: none;
  display: block;
  margin-bottom: 0.25rem;
  transition: color 0.3s ease;
}

.item-name:hover {
  color: #3A2B78FF;
}

.item-description {
  font-size: 0.8rem;
  color: #6c757d;
  margin: 0 0 0.5rem 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.item-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
}

.item-quantity {
  color: #6c757d;
}

.item-price {
  color: #3A2B78FF;
  font-weight: 600;
}

.item-total {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 0.95rem;
  white-space: nowrap;
}

/* Summary Breakdown */
.summary-breakdown {
  padding: 1.2rem 0;
}

.breakdown-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.breakdown-label {
  font-size: 0.95rem;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.breakdown-label i {
  color: #6c757d;
  cursor: help;
}

.breakdown-value {
  font-weight: 600;
  color: #1a1a1a;
  font-size: 0.95rem;
}

.breakdown-divider {
  height: 1px;
  background: #e9ecef;
  margin: 1rem 0;
}

.total-row {
  padding: 1rem;
  background: linear-gradient(135deg, #E6FDFF 0%, #d4f5f7 100%);
  border-radius: 10px;
  margin: 0;
}

.total-row .breakdown-label {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a1a1a;
}

.total-row .breakdown-value {
  font-size: 1.3rem;
  color: #3A2B78FF;
  font-weight: 700;
}

/* Summary Actions */
.summary-actions {
  margin-top: 1.0rem;
}

.btn-place-order {
  width: 100%;
  padding: 1rem 1.2rem;
  background: linear-gradient(135deg, #3A2B78FF 0%, #3A2B78FF 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 1.05rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(20, 0, 168, 0.3);
}

.btn-place-order:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 67, 168, 0.4);
}

.btn-place-order:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.order-content,
.loading-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.btn-spinner {
  width: 1.2rem;
  height: 1.2rem;
}

.security-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
  color: #6c757d;
  font-size: 0.85rem;
}

.security-info i {
  color: #3A2B78FF;
  font-size: 1.1rem;
}

/* Empty Cart State */
.empty-cart-card {
  background: white;
  border-radius: 16px;
  padding: 3rem 2rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
}

.empty-cart-icon {
  width: 120px;
  height: 120px;
  margin: 0 auto 1.5rem;
  background: linear-gradient(135deg, #E6FDFF 0%, #d4f5f7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
  color: #3A2B78FF;
}

.empty-cart-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
}

.empty-cart-card p {
  color: #6c757d;
  margin: 0 0 2rem 0;
  font-size: 1rem;
}

.btn-browse {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 2rem;
  background: linear-gradient(135deg, #00d4d4 0%, #3A2B78FF 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 168, 168, 0.3);
}

.btn-browse:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 168, 168, 0.4);
  color: white;
}

/* Responsive Design */
@media (max-width: 1024px) {

  .summary-card {
    position: static;
  }
}

@media (max-width: 768px) {
  .modern-checkout {
    padding: 1rem 0.5rem;
  }

  .checkout-card {
    padding: 1.5rem;
  }

  .card-header-modern {
    flex-direction: column;
    gap: 0.75rem;
  }

  .header-icon {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
  }

  .header-text h3 {
    font-size: 1.2rem;
  }

  .form-row {
    gap: 1rem;
  }

  .summary-items {
    max-height: 300px;
  }

  .summary-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .item-image {
    width: 100%;
    height: 150px;
  }

  .item-total {
    align-self: flex-end;
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  
  .checkout-card {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }

  .header-text h3 {
    font-size: 1.1rem;
  }

  .payment-content {
    flex-wrap: wrap;
  }

  .payment-icon {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
  }

  .btn-place-order {
    padding: 0.875rem 1.5rem;
    font-size: 1rem;
  }

  .empty-cart-icon {
    width: 100px;
    height: 100px;
    font-size: 3rem;
  }
}

/* Animations */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.checkout-card {
  animation: slideInUp 0.5s ease-out;
}

.summary-card {
  animation: slideInUp 0.6s ease-out;
}

/* Loading State */
.btn-place-order .loading-content {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

/* Accessibility */
*:focus-visible {
  outline: 3px solid #3A2B78FF;
  outline-offset: 2px;
}

.payment-option:focus-within {
  border-color: #3A2B78FF;
  box-shadow: 0 0 0 3px rgba(0, 168, 168, 0.1);
}

/* Print Styles */
@media print {
  .checkout-actions,
  .summary-actions,
  .security-info {
    display: none;
  }

  .checkout-container {
    grid-template-columns: 1fr;
  }

  .checkout-card,
  .summary-card {
    box-shadow: none;
    border: 1px solid #e1e8ed;
  }
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .form-control,
  .payment-option {
    border-width: 3px;
  }

  .btn-place-order,
  .btn-back {
    border-width: 3px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Tooltips for Icons */
.breakdown-label i[title] {
  position: relative;
}

.breakdown-label i[title]:hover::after {
  content: attr(title);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.5rem 0.75rem;
  background: #1a1a1a;
  color: white;
  font-size: 0.8rem;
  white-space: nowrap;
  border-radius: 6px;
  margin-bottom: 0.5rem;
  z-index: 10;
}

/* Success Animation for Checkmark */
@keyframes checkmark {
  0% {
    transform: scale(0) rotate(0deg);
  }
  50% {
    transform: scale(1.2) rotate(180deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
  }
}

.payment-option.active .payment-checkmark i {
  animation: checkmark 0.5s ease-out;
}

/* Smooth Scroll */
html {
  scroll-behavior: smooth;
}

/* Custom Scrollbar for Summary Items */
.summary-items {
  scrollbar-width: thin;
  scrollbar-color: #3A2B78FF #f1f3f5;
}

/* Gradient Text for Total */
.total-row .breakdown-value {
  background: linear-gradient(135deg, #00d4d4 0%, #3A2B78FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Hover Effects for Items */
.summary-item {
  position: relative;
  overflow: hidden;
}

.summary-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(0, 168, 168, 0.1), transparent);
  transition: left 0.5s ease;
}

.summary-item:hover::before {
  left: 100%;
}

/* Badge for Service Fee */
.breakdown-label {
  position: relative;
}

/* Focus States for Better Accessibility */
.form-control:focus,
.btn-place-order:focus,
.btn-back:focus,
.payment-option:focus-within {
  outline: none;
}

/* Loading Overlay Effect */
.btn-place-order:disabled {
  position: relative;
}

.btn-place-order:disabled::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
}

/* Image Loading State */
.item-image img {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.item-image img[src] {
  background: none;
  animation: none;
}

/* Error State for Form */
.form-control.error {
  border-color: #dc3545 !important;
}

.form-control.error:focus {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

/* Success State */
.form-control.success {
  border-color: #28a745 !important;
}

.form-control.success:focus {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
}

/* Placeholder Styling */
.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}

.form-control:focus::placeholder {
  opacity: 0.5;
}

/* Number Input Spinner Remove */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

/* Safari Input Styling Fix */
input[type="text"],
input[type="email"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* Prevent iOS Zoom on Input Focus */
@media screen and (max-width: 768px) {
  input[type="text"],
  input[type="email"],
  input[type="tel"],
  textarea,
  select {
    font-size: 16px !important;
  }
}

/* Button Active State */
.btn-place-order:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 168, 168, 0.3) !important;
}

.btn-back:active {
  transform: translateX(-2px);
}

/* Link Hover Effects */
a {
  transition: all 0.3s ease;
}

/* Divider Animation */
.breakdown-divider {
  position: relative;
  overflow: hidden;
}

.breakdown-divider::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, #3A2B78FF, transparent);
  animation: shimmer 3s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Card Hover Effect */
.checkout-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

.summary-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
}

/* Icon Animations */
.header-icon i,
.summary-header i,
.empty-cart-icon i {
  animation: iconFloat 3s ease-in-out infinite;
}

@keyframes iconFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* Security Badge Animation */
.security-info i {
  animation: shieldPulse 2s ease-in-out infinite;
}

@keyframes shieldPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
</style>